import { Component, ElementRef, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

/** Доля пути, после которой свайп засчитывается */
const DONE = 0.9;

/**
 * Промо-заведение (ROADMAP 5a, 3b): стола и корзины у него нет, поэтому
 * «Это ваше заведение? Свайпните, если да» — в конце меню. Свайп открывает
 * регистрацию edim.app в новом окне
 */
@Component({
    selector: 'app-menu-promo-swipe',
    templateUrl: './menu-promo-swipe.component.html',
    styleUrls: ['./menu-promo-swipe.component.css'],
    standalone: false
})
export class MenuPromoSwipeComponent {
  @ViewChild('track') track!: ElementRef<HTMLElement>;
  @ViewChild('circle') circle!: ElementRef<HTMLElement>;

  /** Сдвиг кружка, px */
  offset = 0;
  dragging = false;

  private startX = 0;

  private get maxOffset(): number {
    return this.track.nativeElement.clientWidth - this.circle.nativeElement.offsetWidth - 12;
  }

  /** Текст бледнеет по мере сдвига */
  get progress(): number {
    return this.offset ? Math.min(1, this.offset / Math.max(1, this.maxOffset)) : 0;
  }

  onDown(event: PointerEvent): void {
    event.preventDefault();
    this.dragging = true;
    this.startX = event.clientX - this.offset;
    this.circle.nativeElement.setPointerCapture(event.pointerId);
  }

  onMove(event: PointerEvent): void {
    if (!this.dragging) return;
    this.offset = Math.max(0, Math.min(this.maxOffset, event.clientX - this.startX));
  }

  onUp(): void {
    if (!this.dragging) return;
    this.dragging = false;
    if (this.offset >= this.maxOffset * DONE) {
      this.offset = this.maxOffset;
      this.openSignUp();
      setTimeout(() => (this.offset = 0), 600);
    } else {
      this.offset = 0;
    }
  }

  /**
   * Новое окно; если браузер его не открыл — переход в этом окне. Без флага
   * 'noopener': с ним window.open всегда возвращает null, и меню уходило бы
   * на регистрацию вслед за новым окном. Связь с меню рвём через opener
   */
  private openSignUp(): void {
    const url = `${environment.appUrl}/signUp`;
    const signUp = window.open(url, '_blank');
    if (signUp) signUp.opener = null;
    else window.location.href = url;
  }
}
